var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatWaveScore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.925 13.994c2.592 0 4.075 1.069 4.075 4.003C24 21.287 21.46 22 19.925 22H0v-1.76h19.925c1.535 0 2.453-1.08 2.453-2.243 0-1.163-.294-2.398-2.453-2.398-1.204 0-.993-1.605 0-1.605Zm-5.874-2.683c2.592 0 4.075.985 4.075 3.689 0 3.032-2.54 3.69-4.075 3.69H0v-1.623h14.05c1.536 0 2.455-.995 2.455-2.067s-.295-2.21-2.454-2.21c-1.204 0-.992-1.48 0-1.48ZM6.784 3.225 5.5 1 4.131 3.37l-2.835-.76.73 2.72L0 6.5l2.025 1.17-.729 2.72 2.835-.76L5.5 12l1.284-2.225 2.29.614-.644-2.405L11 6.5 8.43 5.016l.645-2.405-2.29.614ZM5.5 8.333a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatWaveScore);
export default __webpack_public_path__ + "static/media/heat_wave_score.8af02c8cca046878595eaf104ea415ec.svg";
export { ForwardRef as ReactComponent };